/* One bounded exact-product GET; unknown/failure retain SSR. Zero is never
 * inferred from a photo window. The owning outer wrapper controls all spacing. */
(() => {
  'use strict';
  if(customElements.get('miniami-pdp-latest-reviews'))return;
  customElements.define('miniami-pdp-latest-reviews',class extends HTMLElement {
    connectedCallback(){
      if(this.life||Number(window.Shopify?.theme?.id)!==205457097035||!['main','published','unpublished'].includes(window.Shopify?.theme?.role))return;
      this.life=new AbortController();this.style.display='block';
      requestAnimationFrame(()=>{
        if(!this.isConnected||!this.life)return;
        const api=window.MiniamiReviewMetrics;if(!api)return;
        try{
          this.productSession=api.session(this);
          const reconcile=()=>{
            if(!this.isConnected||!this.life)return;
            const s=this.productSession,outer=this.closest('[data-miniami-pdp-reviews]');if(!outer)return;
            // Exact-product session may be partial; positive records are still
            // positive evidence, but only its qualified all-star closure is zero.
            const retained=!!this.querySelector('.miniami-product-review__card');
            if(s.aggregate?.count>0||s.rows.size>0)outer.hidden=false;
            else if(s.aggregate?.count===0&&!retained)outer.hidden=true;
            for(const card of this.querySelectorAll('.miniami-product-review__card')){
              const row=s.rows.get(card.dataset.reviewSourceId);if(!row?.attachments.length||card.querySelector('[data-review-photo-open]'))continue;
              const photo=row.attachments[0],a=document.createElement('a'),img=document.createElement('img');
              a.className='miniami-product-review__photo';a.dataset.reviewPhotoOpen='';a.href=photo.url;a.setAttribute('aria-label','Open customer photo for '+this.dataset.productTitle);
              img.src=photo.thumbnail;img.alt='Customer photo for '+this.dataset.productTitle;img.width=92;img.height=92;img.loading='lazy';img.decoding='async';a.append(img);card.append(a);card.classList.add('miniami-product-review__card--with-photo');
            }
          };
          document.addEventListener('miniami:product-reviews-updated',e=>{if(e.detail?.id===this.dataset.productId)reconcile();},{signal:this.life.signal});
          api.load(this.productSession,{signal:this.life.signal}).then(()=>{if(this.isConnected){this.dataset.reviewPopulation=this.productSession.aggregate?'qualified-provider-cached':'partial-retained';reconcile();}}).catch(()=>{if(this.isConnected)this.dataset.reviewPopulation='unavailable-retained';});
        }catch(_){this.dataset.reviewPopulation='unavailable-retained';}
      });
    }
    disconnectedCallback(){this.life?.abort();this.life=null;}
  });
})();
